import {StationDashboardRankModel} from '@/types/channel/station/station.model';
import {numberCommaString} from '@/utils/channel';
import {ChannelT} from '@/utils/i18n/channel';
import React from 'react';

interface RankInfoProp {
  rankInfo?: StationDashboardRankModel[];
}
const ChannelRankInfo = ({rankInfo}: RankInfoProp) => {
  if (!rankInfo) {
    return null;
  }

  return (
    <>
      <dl>
        <dt>{ChannelT('순위')}</dt>
        {rankInfo.map((item, index) => (
          <dd key={index}>
            <strong>{item.rankName}</strong>
            <b>
              {ChannelT('{{rank}}위', {
                placeholder: {rank: numberCommaString(item.totalRank)},
              })}
            </b>
          </dd>
        ))}
      </dl>
    </>
  );
};

export default ChannelRankInfo;
